import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
import Style from './style.module.scss';

Modal.setAppElement('#root');

const VideoPopup = ({ isOpen, onClose }) => {
  const { i18n } = useTranslation();
  const videoRef = useRef(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const video = videoRef.current;

    if (isOpen && video) {
      video.currentTime = 0;
      video.muted = true;

      const playPromise = video.play();
      if (playPromise?.catch) {
        playPromise.catch(() => {});
      }
    }

    if (!isOpen && video) {
      video.pause();
      video.currentTime = 0;
    }
  }, [isOpen]);

  const onTimeUpdate = () => {
    const v = videoRef.current;
    if (!v || !v.duration) return;
    setProgress((v.currentTime / v.duration) * 100);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={Style.modal}
      overlayClassName={Style.overlay}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
    >
      <button className={Style.close} onClick={onClose}>
        ✕
      </button>
      <div className={Style.videoWrapper}>
        <video
          ref={videoRef}
          className={Style.video}
          preload="metadata"
          playsInline
          autoPlay
          controls={false}
          controlsList="nodownload"
          disablePictureInPicture
          onTimeUpdate={onTimeUpdate}
          onContextMenu={(e) => e.preventDefault()}
        >
          <source
            src={
              i18n.language === 'tr'
                ? 'https://cdnsc.nesine.com/10953227226/ngaming-video.mp4'
                : 'https://cdnsc.nesine.com/10953227226/ngaming-video-en.mp4'
            }
            type="video/mp4"
          />
        </video>
        <div className={Style.progressTop}>
          <div className={Style.progressFill} style={{ width: `${progress}%` }} />
        </div>
      </div>
    </Modal>
  );
};

export default VideoPopup;
